import React from 'react';
import { useTranslate } from '../../lib/i18n';

interface ResearchConsentButtonsProps {
  onResponse?: (consentGiven: boolean) => void;
  hasResponded?: boolean;
  currentConsent?: boolean | null;
}

const ResearchConsentButtons = ({
  onResponse,
  hasResponded = false,
  currentConsent = null,
}: ResearchConsentButtonsProps) => {
  const t = useTranslate();

  return (
    <div className="mt-4 space-y-3">
      <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-4 min-w-0">
        <button
          onClick={() => onResponse?.(true)}
          className={`flex flex-1 items-center justify-center rounded-lg border border-secondary bg-secondary px-2 py-3 sm:px-6 text-sm sm:text-[16px] text-secondary-foreground hover:opacity-90 transition-opacity min-w-0 ${
            currentConsent === true ? 'opacity-100' : ''
          }`}
        >
          <span className="truncate">{t('researchConsent.giveConsent')}</span>
        </button>
        <button
          onClick={() => onResponse?.(false)}
          className={`flex flex-1 items-center justify-center rounded-lg border border-ring px-2 py-3 sm:px-6 text-sm sm:text-[16px] text-foreground hover:bg-muted transition-colors min-w-0 ${
            currentConsent === false ? 'bg-muted' : ''
          }`}
        >
          <span className="truncate">{t('researchConsent.denyConsent')}</span>
        </button>
      </div>
      {hasResponded && (
        <p className="text-xs text-muted-foreground">{t('researchConsent.canChangeAnswer')}</p>
      )}
    </div>
  );
};

export default ResearchConsentButtons;
